import { SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';
import { PricingInformation } from '../../pricing-information';
import { SerializedAssetDetails } from './serialized-asset-details';

export interface SerializedSubscriptionDetails<T = SubscriptionBookingStatus> extends SerializedAssetDetails {
  confirmedPricingInformation: PricingInformation;
  confirmedTermsVersion: string | null;
  bookingStatus: T;
  endOfPeriod: string;
  endOfNoticePeriod: string | null;
  terminationDate: string;
  webCheckoutLink: string;
  subscriptionManagementLink: string;
}
